/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface AddressR { 
    Street?: string;
    HouseNumber?: number;
    HouseNumberSuffix?: string | null;
    LocationOnStreet?: string | null;
    Postcode?: string | null;
    City?: string;
    Country?: string | null;
}

